import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"edit\">\n    <path d=\"M2.154 24.077v5.769h5.769l17.015-17.015-5.769-5.769-17.015 17.015zM29.4 8.369c0.6-0.6 0.6-1.569 0-2.169l-3.6-3.6c-0.6-0.6-1.569-0.6-2.169 0l-2.815 2.815 5.769 5.769 2.815-2.815z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/edit.svg
// module id = 1855
// module chunks = 0